import { render, staticRenderFns } from "./SearchBruening.vue?vue&type=template&id=122e46d0&scoped=true&"
import script from "./SearchBruening.vue?vue&type=script&lang=js&"
export * from "./SearchBruening.vue?vue&type=script&lang=js&"
import style0 from "./SearchBruening.vue?vue&type=style&index=0&id=122e46d0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "122e46d0",
  null
  
)

export default component.exports